<script>
import gql from 'graphql-tag'
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
import { orderBy } from 'lodash-es'
export default {
  name: 'Song',
  data () {
    return {
      container: null,
      page: 1,
      showMoreEnabled: true,
      isVisible: true,
      limit: 4,
    }
  },
  mixins: [
    platformDetect,
  ],
  apollo: {
    container: {
      /*eslint-disable*/
      query: gql `query pages_par_categorie($categorie: String!, $limit: Int, $page: Int){
        pages_par_categorie(categorie: $categorie, limit: $limit, page: $page){
          id titre page_containers{
            id position container{
              id description titre medias{
                image{
                  url
                }
              }
            }
          }
        }
      }`,
      variables () {
        return { categorie: 'songs_page', limit: 40, page: 1}
      },
      fetchPolicy: 'cache-first',
      update: data => data.pages_par_categorie,
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading (isLoading, countModifier) {
      // isLoading is a boolean
      // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      },
    },
  },
  components: {
    BaseLayout,
  },
  mounted () {
    var body = document.getElementById('app')
    body.style.overflow = 'hidden'
    setTimeout(function () {
      // console.log('tete')
      this.isVisible = false
      // console.log(this.isVisible)
      var temp = document.getElementsByClassName('cd-transition-layer')
      temp[0].style.visibility = 'hidden'
      temp[0].style.position = 'fixed'
    }, 4000)
  },
  computed: {
    dataEnCours () {

    },
  },
  methods: {
    imageFirstPos (chanson) {
      if (chanson.page_containers) {
        var temp = orderBy(chanson.page_containers, ['position'], ['asc'])
        // console.log(temp[0])
        return temp[0].container.medias[0].image.url
      }
    },
    stillData () {
      if (this.page * 4 > this.container.length) {
        return false
      } else {
        return true
      }
    },
    showMore () {
      this.page ++
    },
    showLess () {
      this.page --
    },
  },
}
</script>
<template lang="pug">
base-layout(style='padding-top=-2rem;')
  div.cd-transition-layer(v-bind:class="{ visible: isVisible }")
  div.bgblackintro
  div.backgroundtexture
  div.animatedgradient
  div.song
    div.menucontent
      div.sectiontitre
        div.logosection
          img.logo(src="~@/assets/The_Songs_Button.png", width="200px")
          div.introsection Learn the stories behind many of the most famous Christmas songs written by Jewish songwriters and listen to classic versions.
          hr.lignemenu.mt4

      div.carousel
        div.carouselimages
          div.songcard.relative(v-for='chanson in container')
            div.songtop
              router-link(:to="{name: 'info-song-show', params: {id: chanson.id} }")
                img.imagesong(:src='imageFirstPos(chanson)')

</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*ANIMATIONS*/
.logo{
  -moz-animation: swing 2s 6s;
  -webkit-animation: swing 4s 6s;
  animation: swing 2s 6s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.backgroundtexture{
  -moz-animation: fadeIn 2s;
  -webkit-animation: fadeIn 2s;
  animation: fadeIn 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.lignemenu{
  -moz-animation: zoomIn 2s 6s;
  -webkit-animation: zoomIn 2s 6s;
  animation: zoomIn 2s 6s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.carousel{
  -moz-animation: slideInRight 1s 6s;
  -webkit-animation: slideInRight 1s 6s;
  animation: slideInRight 1s 6s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.sectiontitre{
  -moz-animation: fadeInDown 1s 5s;
  -webkit-animation: fadeInDown 1s 5s;
  animation: fadeInDown 1s 5s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
/*ANIMATIONS END*/
::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}
.bgblackintro{
  position:fixed;
  height:100vh;
  width:100vw;
  background-color: black;
  -moz-animation: fadeOut 2s 4s;
  -webkit-animation: fadeOut 2s 4s;
  animation: fadeOut 2s 4s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.cd-transition-layer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  height: 100%;
  width: 100%;
  opacity: 0;
  /*visibility: hidden;
  overflow: hidden;*/
}
.cd-transition-layer, .bg-layer{
  position: absolute;
  left: 50%;
  top: 50%;
  height: calc(100vw * 0.5625);
  width: calc(100vw * 100);
  /*width: calc(39680px / 9vw);*/
  background: url("~@/assets/transitions/montage_songs_transition.jpg") no-repeat 0 0;
  background-size: 100% 100%;
}
@keyframes cd-sequence {
  0% {
    transform: translateY(-50%) translateX(-0.50%);
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    transform: translateY(-50%) translateX(-100.50%);
    opacity: 0;
  }
}
.cd-transition-layer.visible {
  /*animation: cd-sequence 2.15s steps(62);*/
  animation: cd-sequence 3.7523s steps(100);
  animation-fill-mode: normal;
  /*animation-direction: reverse;*/
  /*animation-timing-function: ease-in;*/
  animation-iteration-count: 1;
  visibility: visible;
}
.animatedgradient{
background: linear-gradient(233deg, #4f0051, #8f0000, #e30000, #ff0000, #ff0000, #fff);
background-size: 1200% 1200%;
min-width:100vw;
width:100%;
opacity:0.5;
min-height:100vh;
height:100%;
z-index:-10;
position:absolute;
mix-blend-mode:hard-light;
-webkit-animation: AnimationName 20s ease infinite;
-moz-animation: AnimationName 20s ease infinite;
-o-animation: AnimationName 20s ease infinite;
animation: AnimationName 20s ease infinite;
}
@-webkit-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@-o-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@media screen and (min-width: 320px){
  .backgroundtexture{
  background-image: url("~@/assets/imgs_bg/fond2.jpg");
  background-size: cover;
  background-position: center;
  height: 100%;
  min-height: 100vh;
  width:100vw;
  z-index:-11;
  position:absolute;
  }
  .introsection{
    color:white;
    width:85%;
    max-width:400px;
    opacity: 1;
    text-align: center;
    margin: 0 auto;
    line-height: 22px;
    font-size: 18px;
    font-style: italic;
    font-family: Crimson Text;
    /*font-family: BritannicBold;*/
  }
  .lignemenu{
    width:60%;
    max-width:500px;
    border-color: white;
    margin-bottom:0px !important;
    overflow: visible; /* For IE */
    height: 30px;
    border-style: solid;
    border-width: 1px 0 0 0;
    border-radius: 20px;
  }
  .lignemenu:after{
    display: block;
    content: "";
    height: 30px;
    margin-top: -31px;
    border-style: solid;
    border-color: white;
    border-width: 0 0 1px 0;
    border-radius: 20px;
  }
  .song{
    & .titresection{
      font-family:Marketdeco;
      color: white;
      font-size: 20px;
      margin-bottom: 30px;
      & span{
        border-style: solid;
        border-width: 3px 0 3px 0;
        border-color: red;
        padding: 5px 10px 5px 10px;
      }
    }
    & .menucontent{
      width: 100%;
      /*height:100vh;*/
      padding-top: 24%;

      & .carousel{
        width:100vw;
        margin-top:30px;
        padding-left:20px;
        overflow-x: auto;

        & .carouselimages{
          /*width:500px;*/
          display:inline-flex;
          white-space: no-wrap;
          & .songcard{
            width:200px;
            margin:30px 10px 10px 10px;
            /*background-color:red;*/
            border-radius:8px;
          }
        }
      }
    }
    & .sectiontitre{
      & .titretestintro{
        font-family: Abril Fatface;
        color:white;
        font-size:24px;
        text-align: center;
      }
      & .titretest{
        font-family: Abril Fatface;
        color:white;
        font-size:60px;
        text-align: center;
      }
    }

    & .menustyle2{
      width:200px;
      margin: 30px auto 20px;
      font-size:20px;
      line-height:24px;
    }
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) and (orientation:landscape) {
.menucontent{
  padding-top:10%!important;
}
}
@media only screen and (min-width: 768px){
  .cd-transition-layer, .bg-layer{
    filter:blur(1px);
  }
  .song{
    & .logosection{
      /*padding-top: 18%;*/
    }
    & .contentsection{
      & .titresection{
        font-family:Marketdeco;
        color: white;
        font-size: 30px;
        margin-bottom: 50px;
        margin-top: 50px;
        & span{
          border-style: solid;
          border-width: 3px 0 3px 0;
          border-color: red;
          padding: 5px 10px 5px 10px;
        }
      }
      & .menucontent{
        width: 100%;
      }
    }
  }
}
@media only screen and (min-width: 768px) and (orientation:landscape) {
  .cd-transition-layer, .bg-layer{
    filter:blur(1px);
  }
  .menucontent{
    padding-top:10%!important;
  }
  .song{
    & .logosection{
      /*padding-top: 10%;*/
    }
  }
}
@media only screen and (min-width: 961px){
  .song{
    & .logosection{
      /*padding-top: 10%;*/
    }
  }
}
@media only screen and (min-width: 1200px){
  .cd-transition-layer, .bg-layer{
    filter:blur(2px);
  }
}
</style>



// WEBPACK FOOTER //
// Song.vue?53073c14